import {
  Button,
  ButtonLink,
  CheckboxFieldController,
  SelectFieldController,
  Stack,
  TextInputFieldController,
} from '@fukuri-admins/ui/common';
import { getClientsLink } from '~/utils/getLinks';
import styles from './styles.module.scss';

/** グループ選択のオプション */
type GroupOption = {
  id: string;
  name: string;
  code: string;
};

type FeatureFlagCheckboxOption = {
  value: string;
  label: string;
  disabled: boolean;
};

type Props = {
  /** 作成ボタンの非活性状態 */
  isButtonDisabled: boolean;
  /** グループの選択肢 */
  groupOptions: GroupOption[];
  /** フォーム送信時のハンドラ */
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
  /** クライアントの機能フラグ */
  featureFlags: FeatureFlagCheckboxOption[];
};

/**
 * 利用企業作成フォームのプレゼンテーションコンポーネント（Legacy版）
 */
export const LegacyCreateClientFormPresentation: React.FC<Props> = ({
  isButtonDisabled,
  groupOptions,
  featureFlags,
  onSubmit,
}) => {
  return (
    <form onSubmit={onSubmit} className={styles.form}>
      <Stack direction='column' gap={24}>
        <h2 className={styles.formTitle}>利用企業の新規作成</h2>
        <TextInputFieldController
          name='name'
          fieldWrapperProps={{
            labelType: 'required',
            labelText: '会社名',
          }}
          textInput={{
            type: 'text',
            placeholder: '合同会社〇〇',
          }}
        />
        <TextInputFieldController
          name='contactPersonName'
          fieldWrapperProps={{
            labelType: 'required',
            labelText: '担当者',
          }}
          textInput={{
            type: 'text',
            placeholder: '山田 太郎',
          }}
        />
        <TextInputFieldController
          name='contactPersonEmail'
          fieldWrapperProps={{
            labelType: 'required',
            labelText: 'メールアドレス',
          }}
          textInput={{
            type: 'email',
            placeholder: 'xxx@xxxx.xx.xx',
          }}
        />
        <TextInputFieldController
          name='contactPersonPhone'
          fieldWrapperProps={{
            labelType: 'required',
            labelText: '電話番号',
          }}
          textInput={{
            type: 'tel',
            placeholder: '090-0000-0000',
          }}
        />
        <TextInputFieldController
          name='corporateNumber'
          fieldWrapperProps={{
            labelText: '法人番号',
          }}
          textInput={{
            type: 'text',
            placeholder: '任意の文字列を入力してください',
          }}
        />
        <TextInputFieldController
          name='employeeCount'
          fieldWrapperProps={{
            labelText: '利用予定者数',
            labelType: 'required',
          }}
          textInput={{
            type: 'number',
            placeholder: '契約時の利用予定人数を入力してください（半角数字）',
          }}
        />
        <TextInputFieldController
          name='externalClientId'
          fieldWrapperProps={{
            labelText: '外部企業ID',
          }}
          textInput={{
            type: 'text',
            placeholder: '任意の文字列を入力してください',
          }}
        />
        {groupOptions.length > 0 && (
          <SelectFieldController
            name='groupId'
            fieldWrapperProps={{
              labelText: 'グループ',
            }}
            select={{
              placeholder: '選択してください',
              options: groupOptions.map(group => ({
                value: group.id,
                label: (
                  <div className={styles.selectOption}>
                    <span className={styles.selectOption__name}>{group.name}</span>
                    <span className={styles.selectOption__code}>（{group.code}）</span>
                  </div>
                ),
              })),
              clearable: true,
            }}
          />
        )}
        <CheckboxFieldController
          name='clientFeatureFlags'
          options={featureFlags}
          fieldWrapperProps={undefined}
        />
        <Stack direction='row' gap={16}>
          <ButtonLink to={getClientsLink()} variant='outline' size='md'>
            キャンセル
          </ButtonLink>
          <Button type='submit' size='md' disabled={isButtonDisabled}>
            作成
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
